// Resolve environment configuration at runtime first (window._env_, injected
// by the container entrypoint into /env-config.js), and fall back to the
// build-time value baked by CRA (process.env). This lets a single built image
// be promoted across environments without a rebuild, while local dev and the
// legacy build path keep working unchanged.
const getEnv = key => {
  if (
    typeof window !== 'undefined' &&
    window._env_ &&
    window._env_[key] != null &&
    window._env_[key] !== ''
  ) {
    return window._env_[key]
  }
  return process.env[key]
}

export const APP_ENV = getEnv('REACT_APP_ENV')
export const isProduction = APP_ENV === 'prod'
export const isStaging = APP_ENV === 'staging'
